module.exports = __webpack_public_path__ + "static/media/fig_10a.c6bbf19f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_10a.jpg
// module id = 627
// module chunks = 0